import { render, staticRenderFns } from "./CameraChart2.vue?vue&type=template&id=65c49024&scoped=true"
import script from "./CameraChart2.vue?vue&type=script&lang=js"
export * from "./CameraChart2.vue?vue&type=script&lang=js"
import style0 from "./CameraChart2.vue?vue&type=style&index=0&id=65c49024&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c49024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c49024')) {
      api.createRecord('65c49024', component.options)
    } else {
      api.reload('65c49024', component.options)
    }
    module.hot.accept("./CameraChart2.vue?vue&type=template&id=65c49024&scoped=true", function () {
      api.rerender('65c49024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/CameraChart2.vue"
export default component.exports